import { AddZoneComponent } from './add-zone/add-zone.component';
import { EditZoneComponent } from './edit-zone/edit-zone.component';
import { ViewZoneComponent } from './view-zone/view-zone.component';    
import { ViewZoneListComponent } from './view-zone-list/view-zone-list.component';

export const ZoneRouting: any = [
    { path: '', redirectTo: 'view-zone', pathMatch: 'full' },
    { path: 'add-zone', component: AddZoneComponent},
    { path: 'view-zone', component: ViewZoneComponent},
    { path: 'edit-zone/:zoneID', component: EditZoneComponent},
    { path: 'single-view-zone/:zoneID', component: ViewZoneListComponent},
];

export const ZoneRoutingBreadcrumbs = [
    { name: 'Single-view', path: '/single-view-zone' },
    { name: 'Edit', path: '/edit-zone' },
    { name: 'Add', path: '/add-zone' },

];
